import React from "react"

import InputTextElement from "./InputTextElement";

const InputEmailControl = ({
    editing,
    required,
    name,
    label,
    autoFocus,
    placeholder,
    type = "email",
    hint,
    icon,
    haserror,
    disabled,
    readonly,
    className = "",
    watchfunction = null,
    value,
    onChange,
    error,
}) => {
    if (!editing) readonly = true;

    return (
        <InputTextElement
            name={name}
            id={name}
            value={value}
            type={type}
            label={label}
            placeholder={placeholder}
            icon={icon}
            hint={hint}
            error={error}
            invalid={Boolean(error) || haserror}
            editing={editing}
            required={required}
            autoFocus={autoFocus}
            disabled={disabled}
            readonly={readonly}
            className={className}
            onChange={onChange}
            watchfunction={watchfunction}
        />
    );
};

export default InputEmailControl;